import { useDebounceCallback } from '@react-hook/debounce';
import { xor } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

const useAutoCompleteList = ({ options, selectedValues, onChange }) => {
  const [keyword, setKeyword] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);

  const isEmpty = useMemo(
    () => filteredOptions.length === 0,
    [filteredOptions.length]
  );

  const onChangeCheckbox = (e, option) =>
    onChange(xor(selectedValues, [option.value]));

  const filterOptions = useDebounceCallback(() => {
    const filteredOptions = options.filter(option => {
      const searchableValue =
        option.searchableValue || option.displayValue || '';
      return searchableValue.includes(keyword);
    });
    setFilteredOptions(filteredOptions);
  }, 400);

  useEffect(() => {
    filterOptions();
  }, [keyword]);

  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  return {
    filteredOptions,
    isEmpty,
    keyword,
    setKeyword,
    onChangeCheckbox
  };
};

export default useAutoCompleteList;
